<template>
  <div id="Particles" :class="className"></div>
</template>
<script>
import * as PIXI from "pixi.js";
let pixi;
let totalSprites = 210;
let totalShapeCount = 9;
let spritesList = [];
let tick = 0;
let mouse = {
  x: undefined,
  y: undefined
};
// create a bounding box box for the little hayachi
const dudeBoundsPadding = 100;
let dudeBounds;
const colorCodes = [0x68caf5, 0x3fc2ff, 0x008bce, 0x8bd2ff, 0xa6c4d9, 0x0067f1];
export default {
  name: "Particles",
  props: {
    animateStep: Number
  },
  computed: {
    className: function() {
      return (this.animateStep > 0) ? "animated" : "";
    }
  },
  methods: {
    generate: index => {
      // PIXI.js ===========================================
      // Particles
      let sprites = new PIXI.ParticleContainer(
        Math.floor(totalSprites / totalShapeCount),
        {
          scale: true,
          position: true
        }
      );
      pixi.stage.addChild(sprites);

      let hayachi = [];
      for (let i = 0; i < totalSprites / totalShapeCount; i++) {
        const _path = require("@/assets/part_" + index + ".png");
        let dude = PIXI.Sprite.from(_path);
        dude.tint = colorCodes[Math.floor(Math.random() * colorCodes.length)];
        //console.log(dude.tint);

        // 画像の中心をきめる
        dude.anchor.set(0.5);

        // 画像のサイズのランダムにきめる
        dude.scale.set(1 + Math.random() * 0.1);

        // ランダムに散らす
        dude.x = Math.random() * pixi.screen.width;
        dude.y = Math.random() * pixi.screen.height;
        dude.a = 0;
        dude.s = (1 + 8 * Math.random() + Math.random() * 1) / 10;

        dude.angle = Math.floor(Math.random() * 4) * 90;

        // ランダムな速度を0〜2の間で作ります。
        dude.speed = (2 + Math.random() * 0.5) * 0.5;

        dude.direction = Math.random() * Math.PI * 2;

        dude.alpha = 0.2;

        // 生成された画像の配列をpushして簡単にアクセスできるようにします
        hayachi.push(dude);

        // ループのデータを反映
        sprites.addChild(dude);
      }
      const el = document.getElementById("Particles");
      el.appendChild(pixi.view);

      const mouse = pixi.renderer.plugins.interaction.mouse.global;
      // 動き
      pixi.ticker.add(() => {
        for (let i = 0; i < hayachi.length; i++) {
          const particle = hayachi[i];
          // 三角関数を使ってランダムな動きをさせる
          particle.x += Math.cos(particle.a) * particle.s * particle.speed;
          particle.y += Math.sin(particle.a) * particle.s * particle.speed;
          particle.a += Math.random() * 0.4 - 0.2;
          // 画面外に出た時の処理
          if (particle.x > dudeBounds.width + 10) {
            particle.x = -5;
          } else if (particle.x < 0 - 10) {
            particle.x = dudeBounds.width + 5;
          } else if (particle.y > dudeBounds.height + 10) {
            particle.y = -5;
          } else if (particle.y < 0 - 10) {
            particle.y = dudeBounds.height + 5;
          }
          // マウスの近くにあるパーティクルはマウスに近寄ってくる
          if (
            mouse.x - particle.x < 80 &&
            mouse.x - particle.x > -80 &&
            mouse.y - particle.y < 80 &&
            mouse.y - particle.y > -80
          ) {
            particle.x += (mouse.x - particle.x) * particle.speed * 0.02;
            particle.y += (mouse.y - particle.y) * particle.speed * 0.02;
          }

          if (i === 0) {
            // console.log(particle.x);
          }
        }
        // increment the ticker
        tick += 0.1;
      });
    },
    calculateWindowWidth: () => {
      if (pixi !== undefined) {
        pixi.renderer.resize(window.innerWidth, window.innerHeight);
        dudeBounds.width = pixi.screen.width + dudeBoundsPadding * 2;
        dudeBounds.height = pixi.screen.height + dudeBoundsPadding * 2;
      }
    }
  },
  mounted() {
    window.addEventListener("resize", this.calculateWindowWidth);
    pixi = new PIXI.Application({
      width: window.innerWidth,
      height: window.innerHeight,
      transparent: true
    });
    dudeBounds = new PIXI.Rectangle(
      -dudeBoundsPadding,
      -dudeBoundsPadding,
      pixi.screen.width + dudeBoundsPadding * 2,
      pixi.screen.height + dudeBoundsPadding * 2
    );
    for (let i = 0; i < totalShapeCount; i++) {
      this.generate(i + 1);
    }
  }
};
</script>
<style scoped>
#Particles {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  bottom: 0;
  overflow: hidden;

  transition: all 0.4s;
  opacity: 0;
}
#Particles.animated {
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/atoms/TheParticles.vue